var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingWelcomeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 628,
    viewBox: "0 0 440 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 628,
    rx: 20,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.055 233.094C345.889 220.722 319.162 227.991 307.111 249.488L286.254 286.452C273.276 307.331 246.239 313.981 225.691 300.835C205.916 288.462 199.272 262.48 210.242 241.755L254.119 164.117C266.169 142.619 259.217 115.399 238.051 103.027C216.885 90.6539 190.157 97.9228 178.106 119.42L56.8266 332.54C44.7759 354.037 52.0372 381.257 72.8943 393.939C94.0603 406.312 120.788 399.043 132.839 377.546L154.777 338.881C166.365 317.074 192.783 308.722 214.258 320.477C235.733 332.231 243.767 359.141 232.335 380.948C231.717 381.876 231.562 382.649 230.944 383.577L185.831 462.917C173.78 484.415 180.733 511.634 201.899 524.007C223.065 536.38 249.793 528.956 261.843 507.613L382.969 294.03C395.328 272.532 388.067 245.312 366.901 232.94L367.055 233.094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingWelcomeCard);
export default __webpack_public_path__ + "static/media/onboarding-welcome-card.018dfd077589a5aa962d2e5d99e124a7.svg";
export { ForwardRef as ReactComponent };